package ru.malygin.myConst

enum class ErrorCode (
    val code: Int,
    val message: String
){
    UNKNOWN_ERROR(
        0, "Неизвестная ошибка"
    ),
    NO_DATA_ERROR(
        1, "Нет данных"
    ),
    INCORRECT_PARAMETERS_ERROR(
        2, "Некорректные данные"
    ),
    JSON_CONVERTER_ERROR(
        3, "JSON converter error"
    ),
    WRONG_TOKEN_ERROR(
        401, "Неверный токен"
    ),
    NOT_FOUND_ERROR(
        404, "Запрашиваемый ресурс не найден"
    ),
    SERVER_ERROR(
        500, "Ошибка сервера"
    )
}

fun String.toErrorCode(): ErrorCode {
    ErrorCode.entries.map {
        if (it.toString() == this) return it
    }
    return ErrorCode.UNKNOWN_ERROR
}